import { render, staticRenderFns } from "./LibrosGomez.vue?vue&type=template&id=009ae87c&scoped=true&"
import script from "./LibrosGomez.vue?vue&type=script&lang=js&"
export * from "./LibrosGomez.vue?vue&type=script&lang=js&"
import style0 from "./LibrosGomez.vue?vue&type=style&index=0&id=009ae87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ae87c",
  null
  
)

export default component.exports